export default __webpack_public_path__ + "static/media/glass_stairs.50a7e783.JPG";